import React, { useState } from 'react';

const TransactionModal = ({ data, onCancel }) => {
  const transaction = data && data.transaction ? data.transaction : null;
  console.log(data);

  const explorerUrl = "https://explorer.quadrans.io/tx/"; //process.env.REACT_APP_EXPLORER_BASE_URL;


  console.log(explorerUrl);




  return (
    <div className="modal-overlay">
      <div className="modal-box big-modal-box">
        <h2 className="modal-title">Dati Blockchain  <span onClick={onCancel} className="close-popup">&#x2715;</span></h2>

          <p style={{marginBottom:"15px"}}>
           <strong>Transazione elemento</strong>: {transaction}
          </p>

          <p style={{marginBottom:"15px"}}>
           <strong>Dattaglio JSON</strong>:
          </p>

          <div style={{marginBottom:"25px", maxHeight:"200px", overflowY:"scroll"}}>

          <pre>
           {JSON.stringify(data).replaceAll("{","{\n  ").replaceAll(",","\n  ").replaceAll("}","\n}")}
          </pre>

          </div>

          <div style={{marginTop:"25px"}} className="buttons center">
            { transaction && explorerUrl &&
              (
                <a href={explorerUrl + transaction}> <button className="modal-button confirm-button">Link Explorer</button> </a>
              )
            }
            <button onClick={onCancel} className="modal-button confirm-button">Chiudi</button>
          </div>
      </div>
    </div>
  );
};

export default TransactionModal;
